import * as Yup from 'yup';

export const noteValidationSchema = Yup.object().shape({
    title: Yup.string().required('Note title is required'),
    note: Yup.string().required('Note is required'),
});

export const meetValidationSchema = Yup.object().shape({
    title: Yup.string().required('Meet title is required'),
    description: Yup.string().required('Meet description is required'),
    date: Yup.string().required('Date is required'),
});
